"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var Utilities_1 = require("../../Utilities");
var PivotItem = (function (_super) {
    tslib_1.__extends(PivotItem, _super);
    function PivotItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PivotItem.prototype.render = function () {
        return (React.createElement("div", tslib_1.__assign({}, Utilities_1.getNativeProps(this.props, Utilities_1.divProperties)), this.props.children));
    };
    return PivotItem;
}(Utilities_1.BaseComponent));
exports.PivotItem = PivotItem;
//# sourceMappingURL=PivotItem.js.map


//////////////////
// WEBPACK FOOTER
// ../~/office-ui-fabric-react/lib/components/Pivot/PivotItem.js
// module id = ../node_modules/office-ui-fabric-react/lib/components/Pivot/PivotItem.js
// module chunks = 1